<app-header (sidenavToggle)="clickMenu()"></app-header>
<app-sidenav [sidenavLayout]="openMenu"></app-sidenav>

